import * as React from "react";
import Svg, { Line, Rect } from "react-native-svg";

export const MeetingPlaceIcon = (props: any) => {
  return (
    <Svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      {...props}
    >
      <Rect width="38" height="38" rx="19" fill="#DBD6E0" />
      <Rect
        x="10"
        y="10"
        width="18"
        height="18"
        rx="2"
        stroke="black"
        stroke-width="2"
      />
      <Line
        x1="14"
        y1="18"
        x2="24"
        y2="18"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
      <Line
        x1="14"
        y1="14"
        x2="22"
        y2="14"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
      <Line
        x1="14"
        y1="22"
        x2="20"
        y2="22"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
    </Svg>
  );
};
